import { render } from "./Hero.vue?vue&type=template&id=e768701e&scoped=true"
const script = {}

import "./Hero.vue?vue&type=style&index=0&id=e768701e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e768701e"]])

export default __exports__